  import { useEffect, useState } from "react";
  import { Accordion, Col, Row, Spinner } from "react-bootstrap";
  // import "slick-carousel/slick/slick.css";
  // import "slick-carousel/slick/slick-theme.css";
  import Slider from "react-slick";
  import ToggleButton from "react-bootstrap/ToggleButton";
  import { useDispatch, useSelector } from "react-redux";
  import { Link, useLocation, useParams } from "react-router-dom";
  import {
    ErrorImg,
    base_url,
    img_url,
    logout,
    postHeader,
    private_key_klaviyo,
    s3_img_url,
  } from "../../../Helper/request";
  import axios from "axios";
  import {
    addOffset,
    detailSlug,
    page,
    productcount,
    productlistdata,
    promostionCount,
    totalcount,
  } from "../../../Reducer/productReducer";
  import Skeleton from "react-loading-skeleton";
  import "react-loading-skeleton/dist/skeleton.css";
  import { wishlistlength } from "../../../Reducer/wishlistReducer";
  import Tooltip from "react-bootstrap/Tooltip";
  import OverlayTrigger from "react-bootstrap/OverlayTrigger";
  import { isMobile } from "react-device-detect";
  import { Helmet } from "react-helmet";

  // faq section
  import { useCallback } from "react";
  import PureComp from "../../PureComp";
import { clickklevu } from "../../../Reducer/homeReducer";

  const staticContents = [
    {
      image: s3_img_url + "plp_ads_1.jpg",
      url: "javascript:void(0)",
    },
    {
      image: s3_img_url + "plp_ads_2.jpg",
      url: "/ring-promise",
    },
    {
      image: s3_img_url + "plp_ads_3.jpg",
      url: "/customer-service/our-warranty",
    },
  ];

  const Productlist = ({ filtercall, setFiltercall }) => {

    const location = useLocation();
    const [screenWidth, setScreenWidth] = useState(window.screen.width);
    const faqMetaText = useSelector(
      (state) => state?.persistedReducer?.meta?.faqMeta
    );
    const categoryName = useSelector(
      (state) => state?.persistedReducer?.product?.categorydetails?.title
    );
    const promotionsItem = useSelector(
      (state) => state?.persistedReducer?.product?.promotionProducts
    );
    const promotionCountData = useSelector(
      (state) => state?.persistedReducer?.product?.promostionCount
    );
    const Offset = useSelector(
      (state) => state?.persistedReducer?.product?.addOffset
    );

    
  const totalProductCount = useSelector(
    (state) => state?.persistedReducer?.product?.productcount
  );


    const resizeScreen = () => {
      setScreenWidth(window.innerWidth);
    };
    useEffect(() => {
      resizeScreen();
      window.addEventListener("resize", resizeScreen);
      return () => {
        window.removeEventListener("resize", resizeScreen);
      };
    }, []);
    useEffect(() => {
      if (filtercall) {
        setLoader(false);
      }
    }, [filtercall]);

    const dispatch = useDispatch();
    const addedfilter = useSelector(
      (state) => state.persistedReducer.product.addedfilter
    );
    const quickshipvalue = useSelector(
      (state) => state.persistedReducer.product.quickshipvalue
    );
    const userdata = useSelector((state) => state.persistedReducer.home.user);
    const prodList = useSelector(
      (state) => state.persistedReducer.product.productlist
    );

    const session_id = useSelector(
      (state) => state.persistedReducer.home.session_id
    );
    const sortbyvalue = useSelector(
      (state) => state.persistedReducer.product.sortbyvalue
    );
    const klevuclicked = useSelector(
        (state) => state.persistedReducer.home.clickklevu
      );
    const { category, search,filterslug } = useParams();
    const product = useSelector((state) => state.persistedReducer.product);
    const [loader, setLoader] = useState(true);
    const [proIndex, setProIndex] = useState("");
    const [addValue, setAddValue] = useState("");

    useEffect(() => {
      if (filtercall) {
        // alert("1")
        dispatch(productlistdata([]));
        dispatch(productcount(0));
        dispatch(addOffset(0));
        // setAddOffset(0)
        if (promotionsItem) {
          dispatch(
            promostionCount(
              40 - promotionsItem[0]?.count ? 40 - promotionsItem[0]?.count : 40
            )
          );
        } else {
          dispatch(promostionCount(40));
        }
        dispatch(page(1));
      }
    }, [addedfilter, quickshipvalue, sortbyvalue, category, filterslug, search]);


    // useEffect(() => {
    //   if (filtercall) {
    //     if (product?.pagecount == 1 || category != product?.listcategory) {
    //       dispatch(productlistdata([]));
    //       dispatch(productcount(0));
    //       dispatch(addOffset(0));
    //       if (promotionsItem && promotionsItem[0]?.page_number == 1 ) {
    //         dispatch(
    //           promostionCount(
    //             promotionsItem[0]?.page_number == 1 && 40 - promotionsItem[0]?.count ? 40 - promotionsItem[0]?.count : 40
    //           )
    //         );
    //         // productlistapi();
    //       } else {
    //          dispatch(promostionCount(40));
    //       }
    //       productlistapi();
    //       // productlistapi();
    //     }
    //   }
    //   return () => {
    //     controller.abort();
    //   };
    // }, [
    //   filtercall,
    //   addedfilter,
    //   quickshipvalue,
    //   sortbyvalue,
    //   product?.pagecount,
    //   search,
    // ]);

    useEffect(() => {
      if (filtercall) {
        if (product?.pagecount == 1 && !product?.productlist?.length) {
          dispatch(productlistdata([]));
          dispatch(productcount(0));
          dispatch(addOffset(0));
          // window.scrollTo(0, 100);
          fetchListHandle()
        }
      }
      return () => {
        controller.abort();
      };
    }, [
      filtercall,
      addedfilter,
      quickshipvalue,
      sortbyvalue,
      product?.pagecount,
      search,
    ]);
    useEffect(() => {
      if (filtercall) {
        if (category != product?.listcategory ) {
          dispatch(productlistdata([]));
          dispatch(productcount(0));
          dispatch(addOffset(0));
          // window.scrollTo(0, 100);
          fetchListHandle()
          // productlistapi();
        }
      }
      return () => {
        controller.abort();
      };
    }, [
      filtercall
    ]);
    const fetchListHandle = useCallback(
      () => {
      if (promotionsItem && promotionsItem[0]?.page_number == 1 ) {
        dispatch(productlistdata([]));
        dispatch(
          promostionCount(
            promotionsItem[0]?.page_number == 1 && 40 - promotionsItem[0]?.count ? 40 - promotionsItem[0]?.count : 40
          ));
        productlistapi();
      } else {
        dispatch(promostionCount(40));
        productlistapi();
      }
    },[
      filtercall,
      addedfilter,
      quickshipvalue,
      sortbyvalue,
      product?.pagecount,
      search,
    ])
    useEffect(() => {
    
      if (filtercall) {
        if (product?.pagecount != 1) {
          productlistapi();
        }
      }
    }, [product?.pagecount]);
    const loadMoreHandle = (event) => {
      // event.preventDefault();
      if (promotionCountData) {
        dispatch(addOffset(Offset + promotionCountData));
      } else {
        dispatch(addOffset(Offset + 40));
      }
      if (product?.productlist?.length == product?.pagecount * 40) {
        // filter add data by page number
      const val1 =  promotionsItem?.filter( (data, i) =>Number(data?.page_number) == Number(product?.pagecount+1) && data?.page_number)

        if (val1?.length) {
          Number(val1[0]?.page_number) == Number(product?.pagecount+1) &&
              dispatch(promostionCount(40 - val1[0]?.count))
        } else {
          dispatch(promostionCount(40))
        }
        dispatch(page(product?.pagecount + 1));
      }
    };
  
    
    const controller = new AbortController();
    // ga4 view_item_list---------start
    const view_item_list_Event = (product_event) => {
      const gaProducts = product_event?.cart_data?.map((product) => ({
        item_id: product.product_id,
        item_name: product.name,
        price: product.price,
      }));
      if (window.gtag) {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag("event", "view_item_list", {
          event: "view_item_list",
          ecommerce: {
            items: [gaProducts],
          },
        });
      }
    };
    // Klaviyo events product list Start
    function kleviyoListTracking(productFeed) {
      var item = {
        Categories: category,
        // Product: productFeed,
        URL: window.location.href,
      };
      if (window?.klaviyo) {
        window.klaviyo.push(["track", "View Product Listing", item]);
      }
    }
    //  useEffect(() => {
    //     if (klevuclicked && search.length) {
    //       productlistapi();
    //     }
    //     dispatch(clickklevu(false));
    //   }, [klevuclicked]);

    const productlistapi = (countVal) => { // uploadProductFeed()
      setLoader(true);
      const data = {
        sort_by: sortbyvalue,
        category: category,
        search: search,
        filterdata: addedfilter,
        limit: promotionCountData ? promotionCountData : 40,
        offset: Offset,
        user_id: userdata?.user_id ? userdata?.user_id : "",
        session_id: session_id,
        quick_ship: quickshipvalue,
        token: userdata?.token ? userdata?.token : "",
      };
      axios
        .post(base_url + "/product/productlist", data, {
          headers: postHeader,
          signal: controller.signal,
        })
        .then((res) => {
          if (res.data.status == 1) {
            setLoader(false);
            dispatch(productcount(res.data.data?.count));
            kleviyoListTracking(res.data.data?.result);
            view_item_list_Event(res.data.data?.result);
            if (product?.pagecount == 1) {
              dispatch(detailSlug(window.location.pathname));
              if (promotionsItem?.length) {
                promotionsItem?.map((itemInnerData, itemindex) =>
                  itemInnerData?.data?.map(
                    (item, itemindex) =>
                      itemInnerData.page_number == 1 ?
                      fixRowCol(item, res.data.data?.result, 1):
                  
                      dispatch(
                        productlistdata([
                          ...product?.productlist,
                          ...res.data.data?.result,
                        ])
                      )
                  )
                );
              } else {
                dispatch(productlistdata(res.data.data?.result));
              }
            } else {
              if (promotionsItem?.length) {
                promotionsItem?.map((itemInnerData, itemindex) =>
                  itemInnerData?.data?.map((item, iteminde) =>
                    product?.pagecount == itemInnerData.page_number
                      ? fixRowCol(item, res.data.data?.result, 2)
                      : dispatch(
                          productlistdata([
                            ...product?.productlist,
                            ...res.data.data?.result,
                          ])
                        )
                  )
                );
              } else {
                dispatch(
                  productlistdata([
                    ...product?.productlist,
                    ...res.data.data?.result,
                  ])
                );
              }
            }
          
            var count = (res.data.data?.count / 40).toFixed();
            if (count * 40 >= res.data.data?.count) {
              dispatch(totalcount(count));
            } else {
              dispatch(totalcount(Number(count) + 1));
            }
          } else if (res.data.status == 2) {
            logout();
          } else {
            dispatch(productlistdata([]));
            dispatch(productcount(0));
            dispatch(totalcount(0));
          }
          // setLoader(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const comninationapi = (group_id, shape, color, click_id) => {
      const data = {
        group_id,
        shape,
        color,
        click_id,
      };
      axios
        .post(base_url + "/product/filter_shape_color_productlist", data, {
          headers: postHeader,
        })
        .then((res) => {
          if (res.data.status == 1) {
            var changedata = product?.productlist?.map((val) =>
              val?.group_id == data?.group_id
                ? Object.assign({}, val, res.data.data?.result[0])
                : val
            );
            var temp = Object.assign(
              [],
              product?.productlist?.result,
              changedata
            );
            dispatch(productlistdata(temp));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    let settings_1 = {
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
    };



    const WishlistProductEvent = (product_event) => {
      const gaProducts = {
        item_id: product_event?.product_id,
        item_name: product_event?.name,
        price: product_event?.price,
      };
      if (window.gtag) {
        window.gtag("event", "add_to_wishlist", {
          event: "add_to_wishlist",
          ecommerce: {
            currency: "USD",
            value: product?.price,
            items: [gaProducts],
          },
        });
      }
    };
      //-----------------------***************************** klaviyo wishlist event start
      function klaviyo_Wishlist(val) {
        var item = {
          ProductName: val?.name,
          ProductID: val?.product_id,
          SKU: val?.sku,
          Categories: val?.category_name,
          ImageURL: val?.product_image[0]?.url,
          Page_URL: window.location.href,
          Price: val?.price,
        };
        if (window?.klaviyo) {
          window.klaviyo.push(["track", "Added to wishlist", item]);
        }
      }
      //----------------------------**************************** klaviyo wishlist event End
    //******Klaviyo events Remove From Wishlist....****** Start
    function kleviyoRemoveWishlist(val) {
      var item = {
        Wishlist_id: val?.cart_id,
        ProductID: val?.product_id,
        ProductName: val?.name,
        price: val?.product_image[0]?.url,
        Page_URL: window.location.href,
        Image_Url: val?.url,
      };
      if (window?.klaviyo) {
        window.klaviyo.push(["track", "Remove From Wishlist", item]);
      }
    }
    // ******Klaviyo events Remove From Wishlist..********* End
    const add_to_wishlist = async (val, group_id, product_id, index) => {
      WishlistProductEvent(val);
      const data = {
        user_id: userdata?.user_id ? userdata?.user_id : "",
        session_id,
        product_id,
        group_id,
        token: userdata?.token ? userdata?.token : "",
      };
      await axios
        .post(base_url + "/product/add_to_wishlist", data, {
          headers: postHeader,
        })
        .then(async (res) => {
          if (res.data.status == 1) {
            dispatch(wishlistlength(res.data.data.count));
            const data1 = await product?.productlist?.map((obj, ind) =>
              index == ind
                ? Object.assign({}, obj, {
                    is_wishlist: res.data.data.wishlist_id,
                  })
                : obj
            );
            dispatch(productlistdata(data1));
          } else if (res.data.status == 2) {
            logout();
          } else {
            dispatch(productcount(0));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);
    const select_item_event = (product_event) => {
      const gaProducts = {
        item_id: product_event?.product_id,
        item_name: product_event?.name,
        price: product_event?.price,
      };
      if (window.gtag) {
        window.gtag("event", "select_item", {
          event: "select_item",
          ecommerce: {
            items: gaProducts,
          },
        });
      }
    };

    const stoneQualtiyHandle = (val) => {
      if (val && val !== "") {
        return "?stone_quality=" + val.replaceAll("+/", "%2B%2F");
      } else {
        return "/";
      }
    };
    // function fixRowCol(item, productL, num) {
    //   const r = item?.row;
    //   const col = item?.position;
    //   const finalPosition = Number(r * 4) - Number(4 - col);
    //   productL.splice(finalPosition - 1, 0, item);
      
    //   if (num === 1) {
    //     dispatch(productlistdata(productL));
    //   } else {
    //     dispatch(productlistdata([...product?.productlist, ...productL]));
    //   }
    // }
    function fixRowCol(items, productL, num, itemInnerData) {
      if(itemInnerData?.length > 1){   
      let updatedList = [...productL];
      
        // Ensure itemInnerData is always an array and each item inside it is also wrapped inside an array
        const itemsArray = Array.isArray(itemInnerData) ? itemInnerData : [itemInnerData];
      
        itemsArray.forEach((item) => {
          const r = item?.row;
          const col = item?.position;
          const finalPosition = Number(r * 4) - Number(4 - col);
      
          // Ensure each inserted item is inside an array
          const wrappedItem = Array.isArray(item) ? item : [item];
      
          // Insert the wrapped item at the finalPosition
          updatedList = [
            ...updatedList.slice(0, finalPosition - 1),
            ...wrappedItem,  // Spread to avoid nesting inside another array
            ...updatedList.slice(finalPosition - 1) // Keep the rest of the array
          ];
        });
        if (num === 1) {
          dispatch(productlistdata(updatedList));
        } else {
          dispatch(productlistdata([...product?.productlist, ...updatedList]));
        }
      }else{
        const r = items?.row;
        const col = items?.position;
        const finalPosition = Number(r * 4) - Number(4 - col);
        
        productL.splice(finalPosition - 1, 0, items);
        if (num === 1) {
          dispatch(productlistdata(productL));
        } else {
          dispatch(productlistdata([...product?.productlist, ...productL]));
        }
      }
      }
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {metaData?.title ? metaData?.title : "Wedding Day Diamonds"}
          </title>
          <meta name="description" content={metaData?.description}></meta>
          <meta name="keywords" content={metaData?.keywords}></meta>
                  <script type="application/ld+json" id="produ">
          {`
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": [
        ${product?.productlist?.length > 0 && product?.productlist?.map(
            (val, index) => `{
              "@type": "ListItem",
              "position": "${index + 1}",
              "url": "${val?.is_custom_product === "1" ? img_url + "custom-product-detail/" : img_url + "product-detail/"}${val?.group_id}/${val?.slug}${val?.stone_quality && val?.stone_quality !== ""
                ? "/" + encodeURI(val?.stone_quality).replaceAll("+/", "%2B%2F")
                : "/"
              }"
            }`
          )
              .join(",")}
      ]
    }
  `}
        </script>
        </Helmet>
        {/* <button onClick={()=>setName("jawed")}>Pure comp</button>
        <PureComp name={name}/> */}

        
        <div className="products_list">
          {/* <InfiniteScroll
          style={{ overflow: 'hidden' }}
          dataLength={product?.productlist?.length / 4}
          next={fetchMoreData}
          hasMore={product?.totalcount > product?.pagecount}
          scrollableTarget="products_list"
          loader={
            <Row>
              {[...Array(isMobile ? 2 : 4)].map((val, i) => (
                <Col md={3} xs={6} className="mt-5" key={i}>
                  <div className="product_box text-center">
                    <div className="product_bg">
                      <Skeleton height={230} />
                      <div className="d-flex justify-content-center">
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                      </div>
                    </div>
                    <h2 className="pro_name">
                      <Skeleton count={2} height={25} variant="text" />
                    </h2>
                    <div className="d-flex justify-content-center my-2">
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                    </div>
                    <span className="">
                      {' '}
                      <Skeleton height={25} variant="text" />
                    </span>
                  </div>
                </Col>
              ))}
            </Row>
          }
        > */}

      
<Row>
          {loader && !product?.productlist?.length
            ? [...Array(product?.pagecount ==1 ? 32 : product?.pagecount*32)].map((val, i) => (
                <Col md={3} xs={6} className="mt-5" key={i}>
                  <div className="product_box text-center">
                    <div className="product_bg">
                      <Skeleton height={230} />
                      <div className="d-flex justify-content-center">
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                        <div className="me-2">
                          <Skeleton
                            className="rounded-circle"
                            height={30}
                            width={30}
                          />
                        </div>
                      </div>
                    </div>
                    <h2 className="pro_name">
                      <Skeleton count={2} height={25} variant="text" />
                    </h2>
                    <div className="d-flex justify-content-center my-2">
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                      <div className="me-2">
                        <Skeleton height={30} width={30} />
                      </div>
                    </div>
                    <span className="">
                      {" "}
                      <Skeleton height={25} variant="text" />
                    </span>
                  </div>
                </Col>
              ))
            : product?.productlist?.map((val, index) => (
                <Col md={3} xs={window.innerWidth < 991 && val?.row  ? 12 : 6} key={index}>
                  {val?.row ? (
                    val?.link ? 
                    <Link to={val?.link}>
                      <img style={{paddingBottom:"5px"}} className="img-fluid" src={val.image} />
                    </Link>
                    :
                    <img  style={{paddingBottom:"5px"}} className="img-fluid" src={val.image} />
                  ) : (
                    <div className={`product_box text-center customProductList `}>
                      <div className="product_bg">
                        {val?.top_pick == "yes" ? (
                          val?.overlay_top_left.length ? (
                            <span className="overlay-top-left-text topPick d-flex align-items-center">
                              {
                              val?.offer_icon_image && <img src={val?.offer_icon_image} className='img-fluid iconData' alt="" />
                            }
                              {val?.overlay_top_left}
                            </span>
                          ) : (
                            ""
                          )
                        ) : val?.overlay_top_left.length ? (
                          <span className="overlay-top-left-text topGift d-flex align-items-center">
                            {val?.offer_icon_image && (
                              <img
                                src={val?.offer_icon_image}
                                className="img-fluid iconData"
                                alt=""
                              />
                            )}
                            {val?.overlay_top_left}
                          </span>
                        ) : (
                          ""
                        )}
                        <Link
                          onMouseOver={() => {
                            setProIndex(index + 1);
                          }}
                          onMouseLeave={() => setProIndex("")}
                          className="img-link"
                          to={`${val?.is_custom_product==="1" ? "/custom-product-detail/" : "/product-detail/"}${val?.group_id}/${val?.slug}${
                            val?.stone_quality && val?.stone_quality !== ""
                              ? "/" +encodeURI(val?.stone_quality).replaceAll("+/", "%2B%2F")
                              : "/"
                          }`}
                          onClick={() => select_item_event(val ?? val)}
                        >
                          <img
                            className="Pro_img"
                            id={"img-" + index + 1}
                            onError={() => ErrorImg("img-" + index + 1)}
                            src={
                              val?.product_image?.length > 1 &&
                              proIndex == index + 1
                                ? val?.product_image[1]?.url
                                : val?.product_image[0]?.url
                            }
                          />
                        </Link>
                        <span className={`${val?.is_custom_product==="1" ? "bgIcons" : ""} iconWrap`}>
                    
                            {
                            val?.is_custom_product!=="1" && 
                        <span className="shipping_icon">
                          <img src={s3_img_url + 'shipping2.png'} alt="Shipping" />
                        </span>
  }
                        <span className="add-to-wishlist">
                          {val.is_wishlist == 0 ? (
                            <img
                              src={s3_img_url + 'heart2.svg'}
                              onClick={() => {
                                klaviyo_Wishlist(val);
                                add_to_wishlist(
                                  val,
                                  val?.group_id,
                                  val?.product_id,
                                  index
                                );
                              }}
                              alt="wishlist"
                            />
                          ) : (
                            <img
                              onClick={() => {
                                kleviyoRemoveWishlist(val);
                                add_to_wishlist(
                                  val,
                                  val?.group_id,
                                  val?.product_id,
                                  index
                                );
                              }}
                              style={{ width: "25px" }}
                              src={s3_img_url + 'product_list/heart-fill-new.svg'}
                              alt="added wishlist"
                            />
                          )}
                        </span>
                        </span>
                        
                        <ul className="pro_metal_color">
                          {val?.colors?.map((color,i) => (
                            <OverlayTrigger
                            key={i}
                              overlay={(props) => (
                                <Tooltip {...props}>{color?.name}</Tooltip>
                              )}
                              placement="top"
                            >
                              <li
                                className={
                                  val?.metalcolor == color.value ? "active" : ""
                                }
                              >
                                <span
                                  onClick={() =>
                                    comninationapi(
                                      val?.group_id,
                                      val?.shape,
                                      color?.value,
                                      1
                                    )
                                  }
                                >
                                  {color?.icon?.length ? (
                                    <img src={color?.icon} alt={color?.name} />
                                  ) : (
                                    <div className="metal_box_noimg">
                                      {String(
                                        color?.name?.split(" ").slice(0, 1)
                                      ).slice(0, 1)}
                                      {String(
                                        color?.name?.split(" ").slice(1, 2)
                                      ).slice(0, 1)}
                                    </div>
                                  )}
                                </span>
                              </li>
                            </OverlayTrigger>
                          ))}
                        </ul>
                        {/* <span className="overlay-bottom-center-text">{val?.overlay_bottom}</span> */}
                      </div>
                      <Link
                    to={`${val?.is_custom_product==="1" ? "/custom-product-detail/" : "/product-detail/"}${val?.group_id}/${val?.slug}${
                      val?.stone_quality && val?.stone_quality !== ""
                        ? "/" +encodeURI(val?.stone_quality).replaceAll("+/", "%2B%2F")
                        : "/"
                    }`}
                      >
                        <h3 className="pro_name">{val?.name}</h3>
                      </Link>
                    
                   

                      {val?.shapes?.length ? (
                        <Slider {...settings_1} className="product_box_shap">
                          {val?.shapes?.map((shape, idx) => (
                            <div key={idx}>
                              <OverlayTrigger
                                overlay={(props) => (
                                  <Tooltip {...props}>{shape.name}</Tooltip>
                                )}
                                placement="top"
                              >
                                <ToggleButton
                                  key={idx}
                                  // id={`shap-${idx}`}
                                  type="radio"
                                  variant={"outline-defult"}
                                  className={
                                    val?.shape == shape.value ? "active" : ""
                                  }
                                  name="shap"
                                  value={shape.value}
                                >
                                  <img
                                    height={22}
                                    width={22}
                                    onClick={() =>
                                      comninationapi(
                                        val?.group_id,
                                        shape?.value,
                                        val?.metalcolor,
                                        2
                                      )
                                    }
                                    src={shape?.icon}
                                    alt={shape.value}
                                  />
                                </ToggleButton>
                              </OverlayTrigger>
                            </div>
                          ))}
                        </Slider>
                      ) : (
                        <div style={{ marginBottom: "-10px" }}></div>
                      )}
                      <h4 className="pro_price">
                        {Number(val?.product_group_count) > 1 && <i>From </i>}
                        {val?.offer_price &&
                          val?.offer_price !== val?.price && (
                            <del
                              style={{ marginRight: "5px" }}
                              className="mr-2"
                            >
                              {val?.currency + val?.price}
                            </del>
                          )}
                        <span
                          className={
                            val?.offer_price && val?.offer_price !== val?.price
                              ? "salmonColor"
                              : ""
                          }
                        >
                          {val?.currency}
                          {val?.offer_price && val?.offer_price == val?.price
                            ? val?.price
                            : val?.offer_price}
                          {!val?.offer_price && val?.price}
                        </span>
                      </h4>
                    </div>
                  )}
                </Col>
              ))}
        </Row>
          {/* </InfiniteScroll> */}
          <div className="text-center mb-5 mt-4">
            {loader && product?.pagecount !== 1 ? (
              <div className="d-flex justify-content-center">
                <button type="button"
                  className="loadMore_Loader  d-flex align-items-center justify-content-center"
                  disabled={true}
                >
                  <Spinner style={{ width: "20px", height: "20px" }} />{" "}
                  <span className="ml-2">Loading...</span>
                </button>
              </div>
            ) : (
              (product?.productlist?.length == product?.pagecount * 40 && Number(totalProductCount) > 40) && (
                <button type="button"
                  className="loadMoreList transition 111"
                  onClick={loadMoreHandle}
                >
                  Load More
                </button>
              )
            )}
            
            {/* {product?.productlist?.length == product?.pagecount * 40 &&
              (!loader ? (
                <button
                  className="loadMoreList transition"
                  onClick={loadMoreHandle}
                >
                  {loader ? "Loading..." : "Load More"}
                </button>
              ) : (
                <h1>Loading....</h1>
              ))} */}
          </div>

          {/* {pageCount > 1 ? <ReactPaginate
          className="d-flex justify-content-center pagination-list mt-5"
          breakLabel="..."
          nextLabel={<IoIosArrowForward />}
          onPageChange={(e) => dispatch(page(e.selected + 1))}
          pageRangeDisplayed={6}
          pageCount={pageCount}
          previousLabel={<IoIosArrowBack />}
          renderOnZeroPageCount={null}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          forcePage={product?.pagecount - 1}
        /> : ""} */}

        
      
          <div className="productListCategoryFAQ">
        
          {faqMetaText?.mainData?.desktop_horizontal  &&
            (screenWidth > 767   ? <img className="img-fluid" src={faqMetaText?.mainData?.desktop_horizontal} alt="Weddign bands" /> :
            <img className="img-fluid" src={faqMetaText?.mainData?.mobile_horizontal} alt="Weddign bands" />)
          }
        
        {
          faqMetaText?.mainData?.description &&   <div className="topbox mb-4">
          <div dangerouslySetInnerHTML={{ __html: faqMetaText?.mainData?.description }} />
        
          </div>
        }
          
          {
            faqMetaText?.data?.length > 0 &&  <Row className="">
            <Col md={12}>
              <h3>FAQs about {categoryName}</h3>
            </Col>
            <Col md={6}>
              {faqMetaText?.data && faqMetaText?.data?.length > 0 && (
                <div className="faqBox">
                  <Accordion className="productListCategoryFAQAccordion">
                    {faqMetaText?.data?.length > 0 &&
                      faqMetaText?.data.map((e, i) => (
                        <Accordion.Item eventKey={e?.id} key={i}>
                          <Accordion.Header>{e?.title}</Accordion.Header>
                          <Accordion.Body> <div dangerouslySetInnerHTML={{ __html: e?.value }} /></Accordion.Body>
                        </Accordion.Item>
                      ))}
                  </Accordion>
                </div>
              )}
          
            </Col>
            <Col md={6}>
              <div className="faqBoximg">
              { faqMetaText?.mainData?.desktop_vertical &&
          screenWidth > 767   ? <img className="img-fluid" src={faqMetaText?.mainData?.desktop_vertical} alt="Weddign bands" /> :
          <img className="img-fluid" src={faqMetaText?.mainData?.mobile_vertical} alt="Weddign bands" />
        }
      
              </div>
            </Col>
          </Row>
          }
          
          </div>
        

    
        </div>
      </>
    );
  };

  export default Productlist;

